<template>
  <div>
    <table
      class="ui celled very compact selectable striped table"
      ref="table"
      style="width:100%"
      v-if="role && role.resources"
    >
      <thead>
        <tr>
          <th>{{ $t("module") }}</th>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("resource") }}</th>
          <th>{{ $t("granted") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(resource, index) in role.resources"
          :key="index"
          v-show="must_show(resource.sys_module)"
        >
          <td>
            {{
              resource.sys_module && resource.sys_module.setup
                ? $t(resource.sys_module.setup.name)
                : "¿?"
            }}
          </td>
          <td>
            {{ resource.name ? resource.name : `[${$t("unnamed")}]` }}
          </td>
          <td>{{ resource.resource }}</td>
          <td>
            <div class="ui toggle checkbox">
              <input
                type="checkbox"
                name="public"
                v-model="role.resources[index].granted"
              />
              <label></label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "RoleModalPermissions",
  components: {},
  data() {
    return {
      allowed_modules: [],
    };
  },
  props: {
    role: Object,
  },
  methods: {
    init_table() {
      //   let vm = this;
      //   let dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
      //   if (vm.$i18n.locale == "es")
      //     dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
      //   else if (vm.$i18n.locale == "fr")
      //     dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";
      //   window.jQuery(vm.$refs.table).DataTable({
      //     language: {
      //       url: dict,
      //     },
      //   });
    },
    set_allowed_modules(modules) {
      let vm = this;
      vm.allowed_modules = modules;
    },
    must_show(mdle) {
      let vm = this;
      if (!mdle) return true;
      else {
        let trgtAllowed = vm.allowed_modules.find((am) => {
          return am.module_id == mdle.module_id;
        });
        if (trgtAllowed) return true;
        else return false;
      }
    },
  },
  mounted() {},
};
</script>
